import { combineReducers } from 'redux';
import { applicationsEntitiesReducer } from './applications.entities';
import { applicationsIdsReducer } from './applications.ids';

export const applicationsReducer = combineReducers({
  ids: applicationsIdsReducer,
  entities: applicationsEntitiesReducer,
});
